import { render, staticRenderFns } from "./DashboardUrls.vue?vue&type=template&id=cbd9c05a&scoped=true"
import script from "./DashboardUrls.vue?vue&type=script&lang=js"
export * from "./DashboardUrls.vue?vue&type=script&lang=js"
import style0 from "./DashboardUrls.vue?vue&type=style&index=0&id=cbd9c05a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd9c05a",
  null
  
)

export default component.exports